import React from 'react';
import ReactDOM from 'react-dom';
import './favicon.ico';
import Frame from './frame';
import Store from './store';
import { Provider } from 'react-redux';
import { Router, Route, IndexRoute } from 'react-router';
import appHistory from 'components/common/appHistory';
import { requireAuthentication } from 'components/common/authenticatedComponent';
import { roleBasedRoute } from 'components/common/roleBasedRoute'
import LoginForm from './containers/login';
import ForgotPWForm from './containers/forgot';
import ResetPWForm from './containers/resetpassword';
import Register from './containers/register';

//import Maintenance from 'components/pages/maintenance';
//----------- Pages are inside frame
import Overview from 'components/pages/overview'
import Locations from 'components/pages/locations/';
import Comparison from 'components/pages/comparison';
import Stats from 'components/pages/stats';
import Live from 'components/pages/live';
import HeatMap from 'components/pages/heatmap';
import DeviceManagement from 'components/pages/devicemanagement';
import User from 'components/pages/user';
import FAQ from 'components/pages/faq';
import API from 'components/pages/api'

import Livefeed from 'components/pages/livefeed'
import Editor from 'components/pages/livefeed/Editor';

//------------settings
import DefaultSettings from 'components/pages/defaultsettings';
import SensorSettings from 'components/pages/sensorsettings';
import MyAccount from 'components/pages/settings/myaccount';

import CountriesAndTimezones from 'countries-and-timezones';
import { initializeIcons } from '@uifabric/icons';
import toastr from "toastr";

toastr.options = {
	"closeButton": true,
	"debug": true,
	"newestOnTop": false,
	"progressBar": false,
	"positionClass": "toast-bottom-right",
	"preventDuplicates": true,
	"onclick": null,
	"showDuration": "300",
	"hideDuration": "300",
	"timeOut": "3000",
	"extendedTimeOut": "1000",
	"showEasing": "swing",
	"hideEasing": "linear",
	"showMethod": "fadeIn",
	"hideMethod": "fadeOut"
}

CountriesAndTimezones.getAllCountries()["--"] = {
	"id": "--",
	"name": "--",
	"timezones": ["UTC"]
}
CountriesAndTimezones.getAllTimezones()["UTC"] = {
	"name": "UTC",
	"utcOffset": 0,
	"offsetStr": "00:00",
	"countries": ["--"]
}
document.charts = {};

initializeIcons();
ReactDOM.render((
	<Provider store={Store}>
		<Router history={appHistory} onUpdate={() => window.scrollTo(0, 0)}>
			<Route path="/" component={requireAuthentication(Frame)}>
				<IndexRoute component={Overview} />
				<Route path="/comparison" component={Comparison} />
				<Route path="/statistic/:id" component={Stats} />
				<Route path="/live/:id" component={Live} />
				<Route path="/heatmap/:id" component={HeatMap} />
				<Route path="/user" component={roleBasedRoute(User)} />
				<Route path="/faq" component={FAQ} />
				<Route path="/locations" component={roleBasedRoute(Locations)} /> {/* not for local user*/}
				<Route path="/devicemanagement/:id" component={roleBasedRoute(DeviceManagement)} />{/* only for company admin*/}
				<Route path="/api" component={roleBasedRoute(API)} /> {/* not for local user*/}
				<Route path="/livefeed" component={Livefeed} />
				<Route path="/livefeed/editor" component={roleBasedRoute(Editor)} /> {/* not for local user*/}
				<Route path="/settings">
					<Route path="/settings/default" component={roleBasedRoute(DefaultSettings)} /> {/* not for local user*/}
					<Route path="/settings/sensor" component={roleBasedRoute(SensorSettings)} />{/* not for local user*/}
					<Route path="/settings/ownaccount" component={MyAccount} />
				</Route>
			</Route>
			<Route path="/login" component={LoginForm} />
			<Route path="/forgot" component={ForgotPWForm} />
			<Route path="/resetpassword" component={ResetPWForm} />
			<Route path="/invitation" component={Register} />
		</Router>
	</Provider>
), document.getElementById('app'));
{/*false ?
			<Router history={appHistory}>
				<Route path="/" component={Maintenance} />
				<Redirect from="*" to="/" />
			</Router>
			:
		*/}


// WEBPACK FOOTER //
// ./src/index.js